import type * as React from 'react';

import { RouterLink } from './RouterLink';

type Props = {
  /** Renders a real link when set, and plain text when there is nowhere to go. */
  to: string | null;
  children: React.ReactNode;
  /** Set for a link wrapping something which has to be able to shrink. */
  fill?: boolean;
};

export default function MaybeLink({ to, children, fill }: Props) {
  if (!to) return <>{children}</>;

  return (
    <RouterLink
      to={to}
      style={fill ? { display: 'block', minWidth: 0 } : undefined}
    >
      {children}
    </RouterLink>
  );
}
